/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/**
 * 客户端类型
 */
export enum ClientType {
    /**
     * 主机
     */
    host = 'host',
    /**
     * 网络组
     */
    net = 'net'
}

/**
 * 智能推荐的客户端类型
 *
 * 主机 host
 *
 * 网络组 net
 */
export enum ClientTypeReceived {
    host = '0',
    net = '1'
}

/**
 * 全局命名空间对象fs
 */
export enum GlobalNamespaceE {
    ID = '18446744073709551613',
    NAME = '/'
}

/**
 * 偏移量offset
 */
export enum OffsetE {
    NONE = 0
}

/**
 * 字符编码枚举 UTF-8:'0'
 */
export enum CharEncodingE {
    UTF8 = '0'
}
